<div
  class="moncompte-wrapper bg-black text-white d-flex align-items-center position-relative"
  (mouseover)="showMenu = true"
  (mouseleave)="showMenu = false"
>
  <img src="assets/perval-icons/person-fill.svg" alt="mon profil" />
  <button class="d-none d-md-block text-white bg-black border-0">
    Mon compte
  </button>
  <img
    class="ms-auto"
    src="assets/perval-icons/chevron-down.svg"
    alt="dérouler mon profil"
  />
  <ul
    *ngIf="showMenu"
    class="position-absolute end-0 top-100 bg-white d-flex flex-column align-items-start"
  >
    <ng-container *ngFor="let item of MENU">
      <li *appHasAccess="item.requiredRoles">
        <a
          *ngIf="!item.v2; else v2link"
          [href]="item | resolveRoute: currentUser"
          >{{ item.label }}</a
        >
        <ng-template #v2link>
          <a [routerLink]="item | resolveRoute: currentUser">{{
            item.label
          }}</a>
        </ng-template>
      </li>
    </ng-container>
  </ul>
</div>
